<div style="position: fixed; top:0; z-index: 1; left:0; height:100%; width:100%; background: #222c;">
</div>


<div style="z-index: 2;  border-radius: 0;" class="centered"
  [ngStyle]="{width: width+'%', left: ((100-width)/2)+'%',top:getTop()} ">
  <div class='padding20 bgLightGrey'>

    <app-a-input [(variable)]="search" [label]="'Search'"></app-a-input>
    <br>
    <div class="padding10 font0_8 primaryColor">
      {{header}}
    </div>
    <ion-row style='max-height: 50vh; overflow-y: scroll; background-color: white;'>
      <ion-col size="12" *ngFor="let category of hierarchy">
        <app-hierarchy [hierarchy]="category" [selected]="selected"></app-hierarchy>
      </ion-col>
    </ion-row>
  </div>
  <ion-badge color="light" mode="ios" *ngFor="let item of selected">{{item}}</ion-badge>
  <div class='padding20 bgLightGrey textCenter'>
    <ion-button (click)="clickClearAll()" fill="outline">
      Clear All
    </ion-button>
    <ion-button (click)="close()">
      Done
    </ion-button>
  </div>
</div>